import Vue from 'vue'
import VueRouter from 'vue-router'

Vue.use(VueRouter)

const routes = [
  {
    path: '/',
    redirect: '/orangTua/login',
  },
  {
    path: '/orangTua/login',
    name: 'orangTua-login',
    component: () => import('@/views/orangTua/Login.vue'),
    meta: {
      layout: 'blank',
    },
  },

 {
    path: '/orangTua/password',
    name: 'ubah-password',
    component: () => import('@/views/orangTua/UbahPassword.vue'),
  },

  {
    path: '/orangTua/dashboard',
    name: 'orangTua-dashboard',
    component: () => import('@/views/orangTua/Dashboard.vue'),
  },
  {
    path: '/orangTua/panduan',
    name: 'panduan-index',
    component: () => import('@/views/orangTua/panduan/PanduanIndex.vue'),
  },
  {
    path: '/orangTua/profil',
    name: 'profil-index',
    component: () => import('@/views/orangTua/profil/ProfilIndex.vue'),
  },
  {
    path: '/mahasiswa/transkripnilai',
    name: 'transkripnilai-index',
    component: () => import('@/views/orangTua/transkripnilai/TranskripNilaiIndex.vue'),
  },
  {
    path: '/mahasiswa/kartuhasilstudi',
    name: 'kartuhasilstudi-index',
    component: () => import('@/views/orangTua/khs/KHSIndex.vue'),
  },
  {
    path: '/orangTua/rekappresensi',
    name: 'rekappresensi-index',
    component: () => import('@/views/orangTua/rekappresensi/RekapPresensiIndex.vue'),
  },
  {
    path: '/orangTua/rekappresensi/:kelas_id',
    name: 'rekappresensi-detil',
    component: () => import('@/views/orangTua/rekappresensi/RekapPresensiDetil.vue'),
  },
  {
    path: '/orangTua/infoPembayaran',
    name: 'info-pembayaran-index',
    component: () => import('@/views/orangTua/infoPembayaran/InfoPembayaranIndex.vue'),
  },
  {
    path: '/error-404',
    name: 'error-404',
    component: () => import('@/views/Error.vue'),
    meta: {
      layout: 'blank',
    },
  },
  {
    path: '*',
    redirect: 'error-404',
  },
]

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes,
})

export default router
